import $ from "jquery";

const header = () => {
  const init = () => {
    handleChangeBackground();
    handleAppend();
    handleAppendCategories();
  };

  const handleChangeBackground = () => {
    const el = {
      header: ".js-Header",
    };

    if ($(el.header).length === 0) return;

    $(window).on("scroll", function () {
      const yOffset = $(window).scrollTop();

      if (yOffset > 10) {
        $(el.header).addClass("mi-OnScroll");
      } else {
        $(el.header).removeClass("mi-OnScroll");
      }
    });
  };

  const handleAppend = () => {
    const el = {
      data: "#js-ForHeader",
    };

    if ($(el.data).length === 0) return;

    const data = $(el.data).data("data");
    Object.entries(data)?.forEach(([key, val]) => {
      const el = `<a class="${val.className}" href="${val.url}">${val.title}</a>`;
      $(key).after(el);
    });
  };

  const handleAppendCategories = () => {
    const el = {
      from: "#js-ForHeaderMenuCategories",
      for: ".js-MenuCategoryProducts",
    };

    if ($(el.from).length === 0) return;

    $(`${el.for} .sub-menu`).remove();

    const datas = $(el.from).data("data");
    const html = `<ul class="sub-menu">
    ${Object.entries(datas)
      ?.map(([key, data]) => {
        return `<li key="${key}" class="menu-item"><a href="${data.link}">${data.name}</a></li>`;
      })
      .join("\n")}
    </ul>`;

    $(el.for).append(html);
  };

  init();
};

try {
  header();
} catch (err) {
  console.error(err);
}
